import React from "react";
import { Tag } from "antd";
import { ShipmentIncompleteStatus } from "@/typedefs/shipment";
import { IncompleteStatusMap } from "@/utils/enum";
const ShipmentIncompleteStatusTag = ({ status = null, bold = false }) => {
    if (status === null || status === undefined) {
        return null;
    }
    return (React.createElement(Tag, { color: "error", style: { fontWeight: bold ? "bold" : "normal" } },
        "Incomplete Status: ",
        IncompleteStatusMap[status]));
};
ShipmentIncompleteStatusTag.defaultProps = {
    status: null,
    bold: false,
};
export default ShipmentIncompleteStatusTag;
